import router from './router'
import store from './store'
import { Message } from 'element-ui'
import { getToken, getTid, setTid, removeTid, getSid, setSid, removeSid } from '@/utils/cookies'

const defaultSettings = require('./settings')

router.beforeEach(async (to, from, next) => {
    const tid = to.query.tid ? to.query.tid : getTid()
    const sid = to.query.sid ? to.query.sid : getSid()

    const {
        domain,
        tougaoInfo,
        tougaoSetting,
        bannerList,
        examInfo,
        examBannerList,
        subjectList
    } = store.getters

    // #region  投稿系统
    if (tid) {
        removeSid(sid)
        setTid(tid)
        document.title = defaultSettings.title
        if (!Object.keys(domain).length) {
            await store.dispatch('tougao/getDomain')
        }

        if (!Object.keys(tougaoInfo).length) {
            await store.dispatch('tougao/getTouGaoInfo', { id: tid })
        }

        if (!Object.keys(tougaoSetting).length) {
            await store.dispatch('tougao/getTouGaoSetting', { tid: tid })
        }

        if (bannerList.length <= 0) {
            await store.dispatch('tougao/getBanner', { tid: tid, type: 10 })
        }

        if (to.path === '/tougao') {
            if (!tid) {
                Message.error('缺少投稿活动的id')
                return false
            }
            const { categoryList } = store.getters
            if (categoryList.length <= 0) {
                await store.dispatch('tougao/getCategoryList', { tid: tid })
            }
        }
    }
    // #endregion

    // #region 考试系统
    if (sid) {
        removeTid(tid)
        setSid(sid)
        document.title = defaultSettings.examTitle
        if (Object.keys(examInfo).length <= 0) {
            await store.dispatch('exam/getSignUpInfo', { id: sid })
        }

        if (examBannerList.length <= 0) {
            await store.dispatch('exam/getBanner', { id: sid, type: '1' })
        }
        if (subjectList.length <= 0 && getToken()) {
            await store.dispatch('exam/getSubjectList', { sid })
        }
    }
    // #endregion

    next()
})

router.afterEach(() => {
    window.scrollTo(0, 0)
})
